import { createSettingsParams } from '@wix/tpa-settings';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import { DemoView } from '@settings/constants';
import { textSettingsParams } from '@settings/Tabs/Text/settingsParams';

export type IAppSettingsParams = {
  demoView: DemoView;
};

export const appSettingsParams = createSettingsParams<IAppSettingsParams>({
  demoView: {
    getDefaultValue: () => DemoView.List,
    metadata: {
      type: DataType.textEnum,
      defaultValue: {
        type: 'static',
        value: DemoView.List,
      },
    },
  },
});

export default {
  ...appSettingsParams,
  ...textSettingsParams,
};
